import App from './App';

export default App;



/** WEBPACK FOOTER **
 ** ./source/app/index.js
 **/